import "./Footer.scss";
import { useEffect, useRef } from "react";
import { simplyClick } from "../../helpers";

export const Footer = ({ step }) => {
  const elRef = useRef(null);

  useEffect(() => {
    const element = elRef.current;
    if (!element) return;

    const initText = element.textContent.trim();
    let previousText = element.textContent.trim();

    const observer = new MutationObserver(() => {
      const currentText = element.textContent.trim();
      if (currentText !== previousText && initText !== currentText) {
        simplyClick("translation_detected", {
          element: "link_disclosures",
          text: currentText.slice(0, 1000),
        });
        previousText = currentText;
      }
    });

    observer.observe(element, {
      childList: true,
      characterData: true,
      subtree: true,
    });

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <>
      <div className="footer__wrapper">
        {step === 1 && (
          <div className="disclaimer_text">
            <p>
              Interchatify is the leading international social network for
              members above 18 that helps you to build connections with users
              worldwide.
            </p>
            <p>
              We are here to help you meet the ones you have been looking for.
            </p>
            <p>
              Fill in brief information about yourself, confirm your
              registration and start chatting with people you like.
            </p>
            <p>
              Attention! All users must be 18+. Сontent that may offend other
              users is strictly prohibited
            </p>
          </div>
        )}
        <div className={"footer-menu"} ref={elRef}>
          <div className={"block"}>
            <a
              href="/terms-of-use/"
              target={"_blank"}
              rel="noreferrer"
              ref={elRef}
            >
              Terms of Use
            </a>
            <a href="/privacy-policy/" target={"_blank"} rel="noreferrer">
              Privacy Policy
            </a>
            <a href="/cookie-policy/" target={"_blank"} rel="noreferrer">
              Cookie Policy
            </a>
          </div>
          <div className={"block"}>
            <a href="/refund-policy/" target={"_blank"} rel="noreferrer">
              Refund Policy
            </a>
            <a href="/billing-policy/" target={"_blank"} rel="noreferrer">
              Billing Policy
            </a>
            <a href="/consent-policy/" target={"_blank"} rel="noreferrer">
              Consent Policy
            </a>
            <a
              href="mailto: support@interchatify.com"
              target={"_blank"}
              rel="noreferrer"
            >
              Contact Us
            </a>
          </div>
        </div>
      </div>
    </>
  );
};
